export const actors = [
  {
    id: "li-lizhen",
    name: "李丽珍",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20warm%20toned%20studio%20portrait%20of%20a%20young%20Asian%20woman%20with%20soft%20smile%2C%20retro%201990s%20film%20still%20aesthetic%2C%20cream%20beige%20background%2C%20gentle%20natural%20lighting&width=400&height=400&seq=actor-lilizhen&orientation=squarish",
    bio: "九十年代香港影坛最具代表性的女演员之一，以清新自然的气质与极具生活感的表演著称。她擅长在轻喜剧与细腻情感戏之间自如切换，塑造的角色往往带着一种不加修饰的真实感，成为一代观众关于“夏天”的集体记忆。",
    filmIds: ["tao-1997", "tao-1993"],
  },
  {
    id: "shu-qi",
    name: "舒淇",
    avatar:
      "https://readdy.ai/api/search-image?query=striking%20warm%20toned%20studio%20portrait%20of%20a%20confident%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20cinematic%20natural%20lighting&width=400&height=400&seq=actor-shuqi&orientation=squarish",
    bio: "从九十年代末崭露头角，凭借独特的气质与不断精进的演技，逐渐成长为亚洲影坛备受尊重的实力派。她的表演兼具疏离与亲近，能在克制的表面下传递复杂情绪，是九十年代港片向新千禧转型期的重要面孔。",
    filmIds: ["tao-1997", "viva-erotica-1996", "glass-1998"],
  },
  {
    id: "zhang-guorong",
    name: "张国荣",
    avatar:
      "https://readdy.ai/api/search-image?query=iconic%20warm%20toned%20studio%20portrait%20of%20a%20charismatic%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20sepia%20background%2C%20timeless%20cinematic%20lighting&width=400&height=400&seq=actor-leslie&orientation=squarish",
    bio: "华语影史与乐坛的传奇人物。他的表演细腻而危险，既能在舞台上光芒万丈，也能在镜头前暴露最脆弱的一面。九十年代他与多位作者导演的合作，重新定义了华语电影的表演高度与情感深度。",
    filmIds: ["happy-1997", "ashes-1994", "days-1990", "once-thief-1991", "viva-erotica-1996"],
  },
  {
    id: "tony-leung",
    name: "梁朝伟",
    avatar:
      "https://readdy.ai/api/search-image?query=refined%20warm%20toned%20studio%20portrait%20of%20a%20thoughtful%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20subtle%20cinematic%20lighting&width=400&height=400&seq=actor-tonyleung&orientation=squarish",
    bio: "以眼神演戏著称的华语影帝。他能用一个背影、一次沉默完成整场情绪的推进，把都市小人物的孤独与温柔刻画得入木三分。九十年代的多部作品奠定了他“最会演沉默”的银幕形象。",
    filmIds: ["chungking-1994", "happy-1997", "ashes-1994"],
  },
  {
    id: "lin-qingxia",
    name: "林青霞",
    avatar:
      "https://readdy.ai/api/search-image?query=timeless%20warm%20toned%20studio%20portrait%20of%20an%20elegant%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20beige%20background%2C%20classic%20cinematic%20lighting&width=400&height=400&seq=actor-linqingxia&orientation=squarish",
    bio: "华语影坛跨越数十年的巨星，既能演绎英气凛然的侠客，也能诠释神秘疏离的都市女性。她在九十年代作品中展现的多面性与气场，至今仍被视为难以复制的银幕典范。",
    filmIds: ["chungking-1994", "ashes-1994"],
  },
  {
    id: "faye-wong",
    name: "王菲",
    avatar:
      "https://readdy.ai/api/search-image?query=distinctive%20warm%20toned%20studio%20portrait%20of%20a%20stylish%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20cool%20cinematic%20lighting&width=400&height=400&seq=actor-fayewong&orientation=squarish",
    bio: "华语乐坛天后，也留下令人难忘的银幕形象。她自带一种不费力的疏离感，把少女的天真与都市的冷静奇妙地融合在一起，成为九十年代香港流行文化最鲜明的符号之一。",
    filmIds: ["chungking-1994"],
  },
  {
    id: "takeshi-kaneshiro",
    name: "金城武",
    avatar:
      "https://readdy.ai/api/search-image?query=handsome%20warm%20toned%20studio%20portrait%20of%20a%20young%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20sepia%20background%2C%20gentle%20cinematic%20lighting&width=400&height=400&seq=actor-kaneshiro&orientation=squarish",
    bio: "以温和内敛的气质成为九十年代文青爱情片的标志性面孔。他的表演不张扬，却能在细微处透出人物的孤独与真诚，是许多经典都市寓言中不可或缺的一道安静注脚。",
    filmIds: ["chungking-1994", "fallen-1995"],
  },
  {
    id: "leon-lai",
    name: "黎明",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20warm%20toned%20studio%20portrait%20of%20a%20tall%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20classic%20cinematic%20lighting&width=400&height=400&seq=actor-leonlai&orientation=squarish",
    bio: "九十年代香港乐坛与影坛的双栖巨星。他的银幕形象温文尔雅，擅长诠释深情而不善言辞的角色，把“错过”与“守候”演绎得极具说服力。",
    filmIds: ["comrades-1996", "fallen-1995", "glass-1998", "eighteen-springs-1997"],
  },
  {
    id: "maggie-cheung",
    name: "张曼玉",
    avatar:
      "https://readdy.ai/api/search-image?query=graceful%20warm%20toned%20studio%20portrait%20of%20an%20elegant%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20refined%20cinematic%20lighting&width=400&height=400&seq=actor-maggie&orientation=squarish",
    bio: "华语影史成就最高的女演员之一。她的表演跨度极大，从明艳到克制皆游刃有余，九十年代的一系列作品让她成为世界影坛认识华语电影的重要窗口。",
    filmIds: ["comrades-1996", "ashes-1994", "days-1990"],
  },
  {
    id: "stephen-chow",
    name: "周星驰",
    avatar:
      "https://readdy.ai/api/search-image?query=expressive%20warm%20toned%20studio%20portrait%20of%20an%20Asian%20man%20with%20playful%20expression%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20cinematic%20lighting&width=400&height=400&seq=actor-stephenchow&orientation=squarish",
    bio: "华语喜剧的代表性人物，以无厘头风格开创了一个时代。他的作品看似荒诞搞笑，内核却常常关乎成长、遗憾与理想主义，让观众笑着笑着就红了眼眶。",
    filmIds: ["china-odyssey-1995"],
  },
  {
    id: "athena-chu",
    name: "朱茵",
    avatar:
      "https://readdy.ai/api/search-image?query=lovely%20warm%20toned%20studio%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20eyes%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20beige%20background%2C%20gentle%20cinematic%20lighting&width=400&height=400&seq=actor-athenachu&orientation=squarish",
    bio: "九十年代港片中最令人难忘的清新面孔之一。她把灵动与赤诚揉进角色，让一个眼神、一个转身都成为观众心中长久的画面。",
    filmIds: ["china-odyssey-1995"],
  },
  {
    id: "karen-mok",
    name: "莫文蔚",
    avatar:
      "https://readdy.ai/api/search-image?query=chic%20warm%20toned%20studio%20portrait%20of%20a%20stylish%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20cool%20cinematic%20lighting&width=400&height=400&seq=actor-karenmok&orientation=squarish",
    bio: "兼具歌手与演员身份的多栖艺人。她的表演带着一种直率的能量，能在夸张与细腻之间自由摆动，为九十年代的银幕带来了截然不同的女性气质。",
    filmIds: ["fallen-1995", "china-odyssey-1995", "viva-erotica-1996"],
  },
  {
    id: "chow-yun-fat",
    name: "周润发",
    avatar:
      "https://readdy.ai/api/search-image?query=charismatic%20warm%20toned%20studio%20portrait%20of%20a%20confident%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20sepia%20background%2C%20dramatic%20cinematic%20lighting&width=400&height=400&seq=actor-chowyunfat&orientation=squarish",
    bio: "华语影坛最具国际影响力的男演员之一。他把潇洒与义气变成了银幕符号，气场强大到能撑起整个画面，是港式动作片黄金时代无可替代的面孔。",
    filmIds: ["once-thief-1991"],
  },
  {
    id: "cherie-chung",
    name: "钟楚红",
    avatar:
      "https://readdy.ai/api/search-image?query=glamorous%20warm%20toned%20studio%20portrait%20of%20an%20elegant%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20warm%20cinematic%20lighting&width=400&height=400&seq=actor-cheriechung&orientation=squarish",
    bio: "八十至九十年代香港影坛的经典美人。她的表演自然松弛，既有都市女性的魅力，也不失率真可爱，与两位男主角的默契配合成就了一部又一部经典。",
    filmIds: ["once-thief-1991"],
  },
  {
    id: "josephine-siao",
    name: "萧芳芳",
    avatar:
      "https://readdy.ai/api/search-image?query=dignified%20warm%20toned%20studio%20portrait%20of%20a%20mature%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20beige%20background%2C%20natural%20cinematic%20lighting&width=400&height=400&seq=actor-siao&orientation=squarish",
    bio: "从童星到影后，纵横影坛数十载。她的表演真实到几乎不着痕迹，能把中年人的疲惫、隐忍与体面同时呈现，是华语影史最令人敬重的演员之一。",
    filmIds: ["summer-snow-1995"],
  },
  {
    id: "anita-mui",
    name: "梅艳芳",
    avatar:
      "https://readdy.ai/api/search-image?query=striking%20warm%20toned%20studio%20portrait%20of%20a%20confident%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20sepia%20background%2C%20dramatic%20cinematic%20lighting&width=400&height=400&seq=actor-anitamui&orientation=squarish",
    bio: "华语乐坛与影坛的传奇“百变天后”。她的气场与演技同样惊人，无论喜剧还是正剧都能稳稳hold住，为九十年代的华语流行文化留下了浓墨重彩的一笔。",
    filmIds: ["eighteen-springs-1997"],
  },
  {
    id: "lung-hsiung",
    name: "郎雄",
    avatar:
      "https://readdy.ai/api/search-image?query=kind%20warm%20toned%20studio%20portrait%20of%20an%20older%20Asian%20man%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20cream%20background%2C%20gentle%20cinematic%20lighting&width=400&height=400&seq=actor-lunghsiung&orientation=squarish",
    bio: "李安电影中“父亲”形象的化身。他以质朴厚重的表演，把传统与现代之间的张力、父辈沉默的爱，演绎得令人动容，成为华语家庭题材电影的重要基石。",
    filmIds: ["eat-drink-1994"],
  },
  {
    id: "wu-chien-lien",
    name: "吴倩莲",
    avatar:
      "https://readdy.ai/api/search-image?query=serene%20warm%20toned%20studio%20portrait%20of%20a%20gentle%20Asian%20woman%2C%20retro%201990s%20film%20still%20aesthetic%2C%20soft%20beige%20background%2C%20soft%20cinematic%20lighting&width=400&height=400&seq=actor-wuqianlian&orientation=squarish",
    bio: "九十年代文艺片中清新而富有韧性的面孔。她的表演安静内敛，擅长用眼神传递角色的隐忍与深情，把时代洪流下的个人命运演绎得细腻动人。",
    filmIds: ["eighteen-springs-1997", "eat-drink-1994"],
  },
];